import http from "./http";

// ─── Tickets ───────────────────────────────────────────────────────────────────

export const getTickets = (status = "open", page = 1) =>
  http.get("/support/tickets/", { params: { status, page } });

export const getTicketDetail = (id) => http.get(`/support/tickets/${id}/`);

export const createTicket = (formData) =>
  http.post("/support/tickets/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateTicketStatus = (id, status) =>
  http.patch(`/support/tickets/${id}/status/`, { status });

// ─── Messages ──────────────────────────────────────────────────────────────────

export const sendMessage = (ticketId, formData) =>
  http.post(`/support/tickets/${ticketId}/messages/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getAllTickets = (params = {}) =>
  http.get("/support/tickets/all/", { params });

export const getUserTickets = (params = {}) =>
  http.get("/support/tickets/", { params });
